<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.1266 14.4963C17.385 14.0192 17.9536 13.8581 18.3966 14.1364L29.5393 21.1363C29.8246 21.3155 30 21.6444 30 22.0001C30 22.3557 29.8246 22.6846 29.5393 22.8639L18.3966 29.8638C18.1094 30.0442 17.7545 30.0455 17.4662 29.8671C17.1779 29.6888 17.0002 29.3581 17.0002 29V19.0001C17.0002 18.4478 17.4159 18.0001 17.9287 18.0001C18.4415 18.0001 18.8573 18.4478 18.8573 19.0001V27.259L27.2286 22.0001L17.4608 15.8639C17.0179 15.5856 16.8682 14.9733 17.1266 14.4963Z"
      fill="currentColor"
    />
  </svg>
</template>
